// extracted by mini-css-extract-plugin
export default {"container":"index__container__9eK0n","iconWrap":"index__iconWrap__1vrjf","icon":"index__icon__1mqbK"};